import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { IonicModule } from "@ionic/angular";
import { PipesModule } from "../pipes/pipes.module";
import { PopoverContentComponent } from "./popover-content/popover-content.component";
import { PopoverDailySpinResultComponent } from "./popover-daily-spin-result/popover-daily-spin-result.component";
import { PopoverIframeComponent } from "./popover-iframe/popover-iframe.component";
import { PopoverSessionStatsComponent } from "./popover-session-stats/popover-session-stats.component";
import { PopoverReconfirmationComponent } from "./popover-reconfirmation/popover-reconfirmation.component";
import { PopoverPreGeoInfoComponent } from "./popover-pre-geo-info/popover-pre-geo-info.component";
import { PopoverSelfExcludeComponent } from "./popover-self-exclude/popover-self-exclude.component";
import { VipTermsComponent } from "./popover-vipterms/popover-vipterms.component";
import { PopoverAlertComponent } from "./popover-alert/popover-alert.component";
import { ComponentsModule } from "../components/components.module";
import { PopoverStandardConfirmComponent } from "./popover-standard-confirm/popover-standard-confirm.component";
import { PopoveApprateComponent } from "./popover-apprate/popover-apprate.component";
import { PopoverWebviewComponent } from "./popover-webview/popover-webview/popover-webview.component";
import { PopoverGameHistoryDetailsComponent } from "./popover-game-history-details/popover-game-history-details.component";
import { PopoverMarketingComponent } from "./popover-marketing/popover-marketing.component";
import { PopoverAgreementComponent } from "./popover-agreement/popover-agreement.component";
import { PopoverDarkWebviewComponent } from "./popover-webview/popover-dark-webview/popover-dark-webview.component";
import { BehalfDeclarationPopover } from "./behalf-declaration/behalf-declaration";
import { PopoverAvailableGamesComponent } from "./popover-available-games/popover-available-games.component";
import { RestrictedMoneyPopover } from "./popover-restricted-money/restricted-money";
import { W2GPopover } from "./w2g/w2g";
import { DatetTimeOnlyFormatPipe } from "../pipes/date-format-timeonly.pipe";
import { PopoverPromotionActionButtonsComponent } from "./popover-promotion-details/promotion-action-buttons/promotion-action-buttons.component";
import { PromotionDetailsPopoverComponent } from "./popover-promotion-details/popover-promotion-details.component";
import { BonusCheckPopoverComponent } from "./popover-bonus-check/popover-bonus-check.component";
import { LoyaltyPopover } from "./loyalty/loyalty";
import { PopoverStringHtmlDisplayComponent } from "./popover-string-html-display/popover-string-html-display.component";

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    BrowserModule,
    FormsModule,
    PipesModule,
    ReactiveFormsModule,
    ComponentsModule,
    DatetTimeOnlyFormatPipe,
  ],
  declarations: [
    VipTermsComponent,
    PopoverAlertComponent,
    PopoverIframeComponent,
    PopoverContentComponent,
    PopoverSessionStatsComponent,
    PopoverReconfirmationComponent,
    PopoverAvailableGamesComponent,
    PopoverDailySpinResultComponent,
    PopoverPreGeoInfoComponent,
    PopoverSelfExcludeComponent,
    PopoverStandardConfirmComponent,
    BehalfDeclarationPopover,
    PopoverDarkWebviewComponent,
    PopoverWebviewComponent,
    PopoverGameHistoryDetailsComponent,
    PopoverMarketingComponent,
    PopoveApprateComponent,
    PopoverAgreementComponent,
    RestrictedMoneyPopover,
    W2GPopover,
    PromotionDetailsPopoverComponent,
    PopoverPromotionActionButtonsComponent,
    BonusCheckPopoverComponent,
    LoyaltyPopover,
    PopoverStringHtmlDisplayComponent
  ],
  exports: [
  ]
})

export class PopoverModule { }